<ion-item class="event-data-block">

  <ion-label>

    @if (event.fecha_inicio_ver) {

      <div class="data">
        <yu-icon slot="start" name="calendar-dots"></yu-icon>
        <span>{{ event.fecha_inicio_ver.ver }}</span>
      </div>

    }

    @if (event.fecha_fin_ver) {

      <div class="data">
        <yu-icon slot="start" name="calendar-check"></yu-icon>
        <span>{{ event.fecha_fin_ver.ver }}</span>
      </div>

    }

    @if (event.duration) {

      <div class="data">
        <yu-icon slot="start" name="timer"></yu-icon>
        <span>{{ event.duration }}</span>
      </div>

    }

    @if (event.people) {

      <div class="data">
        <yu-icon slot="start" name="users"></yu-icon>
        <span>{{ event.people.ver }} PAX</span>
      </div>

    }

  </ion-label>

  <ion-note slot="end">
    <yu-tag [color]="tagManager.getColorTag(event, 'event')">{{ event.estado }}</yu-tag>
  </ion-note>

</ion-item>
